export default __webpack_public_path__ + "static/media/B220.6dbbe711.png";